/** ISO country_code → flag emoji (regional-indicator pair); 📍 fallback. */
export function flag(countryCode: string): string {
  if (!/^[a-z]{2}$/i.test(countryCode)) return "📍";
  return countryCode
    .toUpperCase()
    .replace(/./g, (ch) => String.fromCodePoint(127397 + ch.charCodeAt(0)));
}
